import logdna from "@logdna/browser";
import {
	osName,
	osVersion,
	browserName,
	fullBrowserVersion,
} from "react-device-detect";

const levels = {
	DEBUG: "debug",
	INFO: "info",
	WARN: "warn",
	ERROR: "error",
	FATAL: "fatal",
};

const types = {
	CLIENT: "client",
};

const key =
	process.env.REACT_APP_LOGDNA_API_KEY || "251dfd05dad75bc862f2014b328b850b"; // random key for now
const environment = process.env.REACT_APP_ENV || "localhost";
const app = "App";
let options = {
	hostname: environment,
	app: app,
	indexMeta: true,
};
// Not using until all errors are fixed
if (process.env.REACT_APP_ENV === "production") {
	options.console = {
		integrations: [levels.ERROR],
	};
} else {
	options.console = { enable: false };
}

logdna.init(key, options);

const meta = {
	userId: null,
	clientVersion: process.env.REACT_APP_VERSION,
	browser: browserName,
	browserVersion: fullBrowserVersion,
	osName: osName,
	osVersion: osVersion,
	referrer: document.referrer,
	userAgent: navigator.userAgent,
	type: types.CLIENT,
};

const Logger = (message, level = levels.DEBUG, extraMeta = {}) => {
	logdna.addContext({
		...meta,
		...extraMeta,
		userId: localStorage.getItem("userId") || "Not signed in",
	});
	switch (level) {
		case levels.ERROR:
		case levels.FATAL:
			logdna.error(message);
			break;
		case levels.WARN:
			logdna.warn(message);
			break;
		default:
			logdna.log(message);
	}
};

export { levels };
export default Logger;
